// @ts-nocheck
import { LINK_VIDEO } from "constants/common";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Slider from "react-slick";
import { urlAssetsCustom } from "utils/common";
const BannerSlider = (props) => {
  useEffect(() => {
    console.log("props?.listSlider", props?.listSlider);
  }, [props?.listSlider]);
  const { setContentCard } = props;
  return (
    <div className="slider-container">
      <Slider
        {...props?.listSliderSetting}
        className={`${
          props?.typeSlider == 1 ? "scroll-slider" : "center-slider"
        }`}
      >
        {props?.listSlider?.map((item, i) => {
          return (
            <>
              {props?.typeSlider == 1 ? (
                <div
                  className={`${
                    item?.slider?.length > 1 ? "twopic" : "twopicOther"
                  }`}
                >
                  {item?.slider?.length > 0 ? (
                    <>
                      {item?.slider?.map((item, i) => {
                        return (
                          <div className="twopic-card">
                            <div
                              className="cardWrapper"
                              onClick={() => {
                                props?.clickAction(item.card);
                              }}
                            >
                              <div className="content-image">
                                <img
                                  className="logoCard"
                                  src={urlAssetsCustom(
                                    "assets/img/logoCard.png"
                                  )}
                                />
                                <div className="nameSend">
                                  <h3>
                                    Đến{" "}
                                    <span>
                                      {item.card.receiverName ||
                                        "Gửi mẹ kính yêu"}
                                    </span>
                                  </h3>
                                </div>
                                {/* <p>{item.card.content}</p> */}
                                <p
                                  style={{ whiteSpace: "pre-line" }}
                                  dangerouslySetInnerHTML={{
                                    __html: item?.card?.content,
                                  }}
                                ></p>
                                <img
                                  className="spCard"
                                  src={urlAssetsCustom("assets/img/sp.png")}
                                />
                              </div>
                              <div className="image-card">
                                <img
                                  src={item.card?.imageUrl}
                                  alt={item.card?.imageUrl}
                                />
                              </div>
                            </div>
                            <div className="cover">
                              <div className="btn-wrapper open-card">
                                <button
                                  type="button"
                                  className="btn btn-primary "
                                  onClick={() => {
                                    props?.clickAction(item.card);
                                  }}
                                >
                                  <a>Nhấn để xem lời chúc</a>
                                </button>
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    </>
                  ) : (
                    <>
                      <div className="twopic-card">
                        <div
                          className="cardWrapper"
                          onClick={() => {
                            props?.clickAction(item);
                          }}
                        >
                          <div className="content-image">
                            <img
                              className="logoCard"
                              src={urlAssetsCustom("assets/img/logoCard.png")}
                            />
                            <div className="nameSend">
                              <h3>
                                Đến{" "}
                                <span>
                                  {item.receiverName || "Gửi mẹ kính yêu"}
                                </span>
                              </h3>
                            </div>
                            <p
                              style={{ whiteSpace: "pre-line" }}
                              dangerouslySetInnerHTML={{
                                __html: item?.content,
                              }}
                            ></p>
                            <img
                              className="spCard"
                              src={urlAssetsCustom("assets/img/sp.png")}
                            />
                          </div>
                          <div className="image-card">
                            <img src={item?.imageUrl} alt={item.imageUrl} />
                          </div>
                        </div>
                        <div className="cover">
                          <div className="btn-wrapper open-card">
                            <button
                              type="button"
                              className="btn btn-primary "
                              onClick={() => {
                                props?.clickAction(item);
                              }}
                            >
                              <a>Nhấn để xem lời chúc</a>
                            </button>
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                </div>
              ) : (
                <>
                  <div
                    className="picCard"
                    onClick={() => {
                      props?.clickAction(item);
                    }}
                  >
                    <img src={item.rawImageUrl} alt={item.rawImageUrl} />{" "}
                  </div>
                  <div className="cover">
                    <div className="btn-wrapper open-card">
                      <button
                        type="button"
                        className="btn btn-primary "
                        onClick={() => {
                          props?.clickAction(item);
                        }}
                      >
                        <a>Nhấn để xem câu chuyện của mẹ</a>
                      </button>
                    </div>
                  </div>
                </>
              )}
            </>
          );
        })}
      </Slider>
    </div>
  );
};
export default BannerSlider;
